import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";

var Link = function Link(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      href = _ref.href;
  var getClassName = getClassNameFactory("SearchFiltersLink");
  var ElementType = href ? "a" : "span";
  var linkProps = {
    className: getClassName({
      modifiers: disabled ? "disabled" : ""
    })
  };

  if (href) {
    linkProps.href = href;
    linkProps.rel = "nofollow";
  }

  return /*#__PURE__*/React.createElement(ElementType, linkProps, children);
};

Link.displayName = "SearchFilters.Link";
export default Link;